// The diorama island: ground slab and its earth base.
import * as THREE from 'three';
import { M, add } from '../lib/factory.js';
import { slabGeo } from '../lib/shapes.js';
import { asphalt } from '../textures/ground.js';

export let ISLAND;

export function buildIsland() {
  // ---------- diorama island ----------
  ISLAND = 65;
  // island footprint: rounded to the north, cut straight under the beach so the sand meets the sea
  function islandShape(south) {
    const W = (x, z) => [x, -z],
      o = new THREE.Shape(),
      R = 14,
      E = ISLAND;
    o.moveTo(...W(-E, south));
    o.lineTo(...W(-E, -E + R));
    o.quadraticCurveTo(...W(-E, -E), ...W(-E + R, -E));
    o.lineTo(...W(E - R, -E));
    o.quadraticCurveTo(...W(E, -E), ...W(E, -E + R));
    o.lineTo(...W(E, south));
    o.closePath();
    return o;
  }
  add(
    slabGeo(islandShape(51.5), 1.2),
    [M(0xffffff, { map: asphalt, flatShading: false }), M(0x7a7670)],
    0,
    -1.2,
    0,
  );
  add(slabGeo(islandShape(51.5), 4), M(0xa1714a), 0, -5.2, 0);
}
